import type { OutboxStore, PendingPractice } from './practice-outbox.js';

const KEY = 'coachtools:practice-outbox';

/** Held for this visit only where the browser refuses storage. */
let memory: PendingPractice[] = [];

/** This phone's practices not yet with the server. */
export const practiceOutboxStore: OutboxStore = {
  read() {
    try {
      const saved = window.localStorage.getItem(KEY);
      return saved ? (JSON.parse(saved) as PendingPractice[]) : memory;
    } catch {
      return memory;
    }
  },
  write(list) {
    memory = list;
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (cause) {
      console.error('Keeping a practice on this phone failed:', cause);
    }
  },
};
